import { Component } from '@angular/core';

@Component({
    selector: 'jhi-mention-legale',
    templateUrl: './mention-legale.component.html',
    styleUrls: ['./mention-legale.component.scss']
})
export class MentionLegaleComponent {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/layouts/footer/mention-legale/mention-legale.component.ts